import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import {
  ButtonModule, IconModule, OkDialog, PopoverDirective,
} from '@hglobal/common';
import { AuthActions, AuthService } from '@pt/auth';
import { AvatarModule } from '@pt/components';

import { UserProfileSelectors, UserProfileViewModel } from './store';

@Component({
  selector: 'aa-header-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  imports: [
    AsyncPipe,
    AvatarModule,
    ButtonModule,
    IconModule,
    TranslateModule,
    PopoverDirective,
  ],
})
export class UserProfileComponent {
  readonly #store = inject(Store);
  readonly #okDialog = inject(OkDialog);
  readonly #destroyRef = inject(DestroyRef);
  readonly #authService = inject(AuthService);

  vm$: Observable<UserProfileViewModel> = this.#store.select(UserProfileSelectors.selectViewModel);

  logout(): void {
    this.#authService.logout();
  }

  remove2fa(): void {
    this.#okDialog
      .open({
        headerKey: 'personalInfo.remove2faDialog.header',
        subMessageKey: 'personalInfo.remove2faDialog.message',
        btnOkKey: 'personalInfo.remove2faDialog.yes',
        btnCancelKey: 'personalInfo.remove2faDialog.no',
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(value => {
        if (value) {
          this.#store.dispatch(AuthActions.remove2fa.action());
        }
      });
  }
}
